import Vue from 'vue';
import $axios from '../api/axios'

const trackAction = (type, value, arg) => {
    const pat = {
        actionsLogsVOList: type !== 'list' ? [value] : value
    }
    $axios.post('/api/actions-log', pat).then(res => {

    }).catch(err => {
        console.log(err)
    })
}

export default trackAction;


// WEBPACK FOOTER //
// ./src/utils/action.js